import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Section from '@components/common/Section';
import api from '@common/utils/api';
import OrdersCard from './OrdersCard';
import AppointmentCard from './AppointmentCard';
import ReturnCard from './ReturnCard';
const MyFeedHightlights = (props) => {
    const { t } = useTranslation();
    const [orders, setOrders] = useState(null);
    const [orderReturns, setOrderReturns] = useState(null);
    const [appointments, setAppointments] = useState(null);
    const [menuSelected, setMenuSelected] = useState('orders');
    const onChangeMenu = (e) => {
        setMenuSelected(e.target.value);
    };
    useEffect(() => {
        api
            .MyFeedHighlights()
            .then((res) => {
            if (!res.orders && res.returnOrders) {
                setMenuSelected('returns');
            }
            else if (!res.orders && !res.returnOrders && res.appointments) {
                setMenuSelected('appointments');
            }
            setOrders(res.orders);
            setOrderReturns(res.returnOrders);
            setAppointments(res.appointments);
        });
    }, []);
    if (!orders && !orderReturns && !appointments)
        return React.createElement(React.Fragment, null);
    return (React.createElement("section", { className: "col-12 myfeed-highlights" },
        React.createElement(Section, { introSection: true, title: t('account.highlights.title') }),
        React.createElement("div", { className: "optionbox no-scroolbar", "aria-controls": "myfeed-dinamic-content" },
            (orders === null || orders === void 0 ? void 0 : orders.length) > 0 ? (React.createElement("label", { key: "orders", className: "optionbox__item" },
                React.createElement("input", { type: "radio", className: "optionbox__item__radio", value: "orders", checked: menuSelected === 'orders', onChange: onChangeMenu }),
                React.createElement("div", { className: "optionbox__item__content" }, t('account.highlights.menu.orders')))) : null,
            (orderReturns === null || orderReturns === void 0 ? void 0 : orderReturns.length) > 0 ? (React.createElement("label", { key: "returns", className: "optionbox__item" },
                React.createElement("input", { type: "radio", className: "optionbox__item__radio", value: "returns", checked: menuSelected === 'returns', onChange: onChangeMenu }),
                React.createElement("div", { className: "optionbox__item__content" }, t('account.highlights.menu.returns')))) : null,
            (appointments === null || appointments === void 0 ? void 0 : appointments.length) > 0 ? (React.createElement("label", { key: "appointments", className: "optionbox__item" },
                React.createElement("input", { type: "radio", className: "optionbox__item__radio", value: "appointments", checked: menuSelected === 'appointments', onChange: onChangeMenu }),
                React.createElement("div", { className: "optionbox__item__content" }, t('account.highlights.nenu.appointments')))) : null),
        React.createElement("div", { className: "row myfeed-highlights__wrapper", id: "myfeed-dinamic-content" },
            menuSelected === 'orders' && orders ? orders.map((order) => React.createElement(React.Fragment, { key: order.orderNumber },
                React.createElement(OrdersCard, { order: order, cService: props.cService }))) : null,
            menuSelected === 'appointments' && appointments ? appointments.map((appointment) => React.createElement(React.Fragment, { key: appointment.code },
                React.createElement(AppointmentCard, { appointment: appointment, appointmentsUrl: props.appointmentsUrl }))) : null,
            menuSelected === 'returns' && orderReturns ? orderReturns.map((orderReturn) => React.createElement(React.Fragment, { key: orderReturn.returnCaseNumber },
                React.createElement(ReturnCard, { orderReturn: orderReturn, faq: props.faq, cService: props.cService }))) : null)));
};
export default MyFeedHightlights;
